__turbopack_context__.v({
  "body": "HeadingBlock-module-scss-module__taj4HW__body",
  "body_rich_text": "HeadingBlock-module-scss-module__taj4HW__body_rich_text",
  "content": "HeadingBlock-module-scss-module__taj4HW__content",
  "eyebrow": "HeadingBlock-module-scss-module__taj4HW__eyebrow",
  "heading-block": "HeadingBlock-module-scss-module__taj4HW__heading-block",
  "heading-block__center": "HeadingBlock-module-scss-module__taj4HW__heading-block__center",
  "heading-block__small": "HeadingBlock-module-scss-module__taj4HW__heading-block__small",
  "heading_block_inverse": "HeadingBlock-module-scss-module__taj4HW__heading_block_inverse",
  "heading_ctas": "HeadingBlock-module-scss-module__taj4HW__heading_ctas",
  "subheading": "HeadingBlock-module-scss-module__taj4HW__subheading",
  "title": "HeadingBlock-module-scss-module__taj4HW__title",
});
